import { TeamSide } from '@collector/shared-domain'
import { Incident } from '@collector/sportsapi-client'
import {
  BetStartAttribute,
  BetStopAttribute,
  BookingMarketsDisabledAttribute,
  BookingMarketsEnabledAttribute,
  Confirmation,
  CornerMarketsDisabledAttribute,
  CornerMarketsEnabledAttribute,
  IncidentAttributeId,
} from '@collector/sportsapi-client-legacy'

import { Coordinates } from './coordinates'

export const masterAttributes: IncidentAttributeId[] = [
  BetStartAttribute.Master,
  BetStopAttribute.Master,
  BookingMarketsEnabledAttribute.Master,
  BookingMarketsDisabledAttribute.Master,
  CornerMarketsEnabledAttribute.Master,
  CornerMarketsDisabledAttribute.Master,
]

export function hasIncidentPosition(incident: Incident): boolean {
  return incident.x_pos !== null && incident.y_pos !== null
}

export function isIncidentDeleted(incident: Incident): boolean {
  return incident.action === 'delete'
}

export function isIncidentCancelled(incident: Incident): boolean {
  return incident.confirmation === Confirmation.Cancelled
}

export function isIncidentEditable(incident: Incident): boolean {
  return !isIncidentDeleted(incident) && !isIncidentCancelled(incident)
}

export function isEmergencyIncident(
  incident: Partial<Pick<Incident, 'category'>>,
): boolean {
  return incident.category === 'emergency'
}

/**
 * Normalize coordinate 'x' of incident for teamSide, as if participant was playing on home side
 */
export function getCoordinateXForTeamSide(
  coordinateX: Coordinates['x'],
  teamSide: TeamSide,
): Coordinates['x'] {
  return teamSide === 'home' ? coordinateX : 100 - coordinateX
}

export function isDangerousAttackForCoordinateX(
  coordinateX: Coordinates['x'],
): boolean {
  return coordinateX >= 75 && coordinateX <= 100
}

export type HasIncidentMasterAttribute = typeof hasIncidentMasterAttribute

export function hasIncidentMasterAttribute(incident: Incident): boolean {
  return (
    incident.attribute_ids?.some((attributeId) =>
      masterAttributes.includes(attributeId),
    ) ?? false
  )
}
